import MyPracticeDataLoader from './MyPracticeDataLoader'
export default MyPracticeDataLoader
